import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config/Global.json";
import CustomInput from "../../custominput/CustomInput";

const base64Decode = (encodedStr) => {
  try {
    if (encodedStr) {
      return atob(encodedStr.replace(/_/g, "/").replace(/-/g, "+"));
    }
  } catch (e) {
    console.error("Error decoding Base64 string", e);
    return "";
  }
};

const CreateNewPassword = () => {
  const { temp_token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [firstName, setFirstName] = useState("");
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const parts = (temp_token || "").split(".");
    setToken(parts[0] || "");
    setFirstName(base64Decode(parts[1]));
    setErrors({});
  }, [temp_token]);

  const checkValidPassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(password)) {
      return {
        password:
          "Password must be at least 8 characters long, and include at least one digit, one uppercase letter, and one special character.",
      };
    }
    return {};
  };

  const handleBlur = (field) => {
    let validationErrors = {};
    if (field === "newPassword") {
      validationErrors = checkValidPassword(newPassword);
    }
    if (field === "confirmPassword" && newPassword !== confirmPassword) {
      validationErrors.confirmPassword = "Passwords do not match.";
    }
    setErrors((prev) => ({ ...prev, ...validationErrors }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const apiBaseUrl = config.api.host;
    const confirmPasswordEndpoint = config.api.confirmPassword;

    if (!token || Object.keys(errors).length > 0 || newPassword !== confirmPassword) {
      return;
    }

    try {
      const url = `${apiBaseUrl}${confirmPasswordEndpoint}${token}/`;
      await axios.post(url, { new_password: newPassword });
      toast.success("Password has been reset successfully");
      navigate("/success-msg");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to reset password");
    }
  };

return (
  <div className="pv-new-password-card">
    <style>{newPasswordStyles}</style>
    <div className="pv-new-password-icon">
      <i className="fa-solid fa-lock" />
    </div>
    <h2>Create new password</h2>
    <p>
      {firstName ? <>Hi <strong>{firstName}</strong>, </> : null}
      Choose a strong password to safely restore your PaisaVara access.
    </p>

      <form onSubmit={handleSubmit}>
        <div className="pv-new-password-field">
          <CustomInput
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            onBlur={() => handleBlur("newPassword")}
          />
          {errors.password && <div className="pv-new-password-error">{errors.password}</div>}
        </div>
        <div className="pv-new-password-field">
          <CustomInput
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onBlur={() => handleBlur("confirmPassword")}
          />
          {errors.confirmPassword && <div className="pv-new-password-error">{errors.confirmPassword}</div>}
        </div>
        <button
          type="submit"
          className="pv-new-password-primary"
          disabled={!token || Object.keys(errors).length > 0 || newPassword !== confirmPassword}
        >
          Reset password
        </button>
      </form>
  </div>
);

};

const newPasswordStyles = `
  .pv-new-password-card {
    width: min(470px, 100%);
    margin: 0 auto;
    padding: 8px 2px;
  }

  .pv-new-password-icon {
    width: 66px;
    height: 66px;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0d532f;
    background: linear-gradient(135deg, #dcfce7, #fef3c7);
    font-size: 25px;
    margin-bottom: 18px;
  }

  .pv-new-password-card h2 {
    color: #0f172a;
    font-size: clamp(30px, 4vw, 42px);
    line-height: 1.05;
    font-weight: 950;
    letter-spacing: -0.03em;
    margin: 0 0 12px;
  }

  .pv-new-password-card p {
    color: #64748b;
    font-size: 16px;
    line-height: 1.55;
    margin: 0 0 24px;
    font-weight: 650;
  }

  .pv-new-password-field {
    margin-bottom: 18px;
  }

  .pv-new-password-error {
    color: #dc2626;
    font-size: 13px;
    font-weight: 750;
    margin-top: 8px;
  }

  .pv-new-password-primary {
    width: 100%;
    min-height: 58px;
    border: 0;
    border-radius: 18px;
    background: #0d532f;
    color: #ffffff;
    font-size: 18px;
    font-weight: 900;
    box-shadow: 0 16px 34px rgba(13, 83, 47, 0.22);
  }

  .pv-new-password-primary:disabled {
    cursor: not-allowed;
    background: #94a3b8;
    box-shadow: none;
  }
`;

export default CreateNewPassword;
